import { RootState } from "../../../redux/store";
import { useStore } from "react-redux";
import { EventEditionDetails } from "../../types";

export const useGetMetadataForSync = () => {
  const { getState } = useStore();

  const getMetadataForSync = () => {
    const eventEditionStore = (getState() as RootState).eventEdition;
    if (!eventEditionStore.eventEdition) {
      return { gbsCode: '', pass: '', location: '', eventEdition: {} as unknown as  EventEditionDetails, products: [], orders: [] };
    }
    const { eventEdition, badgeLocation, eventSecret } = eventEditionStore;
    return { gbsCode: eventEdition.gbsCode, location: badgeLocation, pass: eventSecret, eventEdition, products: (getState() as RootState).magento.regProducts };
  };

  return { getMetadataForSync };
};
